import { createAction } from "@reduxjs/toolkit";
export var RecipeListActionType;
(function (RecipeListActionType) {
    RecipeListActionType["LOAD_LIST"] = "RECIPES/LOAD_LIST";
    RecipeListActionType["LOAD_LIST_SUCCESSFUL"] = "RECIPES/LOAD_LIST_SUCCESSFUL";
    RecipeListActionType["LOAD_LIST_FAILURE"] = "RECIPES/LOAD_LIST_FAILURE";
    RecipeListActionType["IMPORT"] = "RECIPE/IMPORT";
    RecipeListActionType["IMPORT_SUCCESSFUL"] = "RECIPE/IMPORT_SUCCESSFUL";
    RecipeListActionType["IMPORT_FAILURE"] = "RECIPE/IMPORT_FAILURE";
    RecipeListActionType["PARSE"] = "RECIPE/PARSE";
    RecipeListActionType["PARSE_SUCCESSFUL"] = "RECIPE/PARSE_SUCCESSFUL";
    RecipeListActionType["PARSE_FAILURE"] = "RECIPE/PARSE_FAILURE";
    RecipeListActionType["CLEAR_PARSED"] = "RECIPE/CLEAR_PARSED";
})(RecipeListActionType || (RecipeListActionType = {}));
export const loadRecipeList = createAction(RecipeListActionType.LOAD_LIST);
export const loadRecipeListSuccessful = createAction(RecipeListActionType.LOAD_LIST_SUCCESSFUL);
export const loadRecipeListFailure = createAction(RecipeListActionType.LOAD_LIST_FAILURE);
export const importRecipe = createAction(RecipeListActionType.IMPORT);
export const importRecipeSuccessful = createAction(RecipeListActionType.IMPORT_SUCCESSFUL);
export const importRecipeFailure = createAction(RecipeListActionType.IMPORT_FAILURE);
export const parseRecipe = createAction(RecipeListActionType.PARSE);
export const parseRecipeSuccessful = createAction(RecipeListActionType.PARSE_SUCCESSFUL);
export const parseRecipeFailure = createAction(RecipeListActionType.PARSE_FAILURE);
export const clearRecipeParsedData = createAction(RecipeListActionType.CLEAR_PARSED);
